export type YeloAppBridgeEvent =
  | "booking_complete"
  | "payment_complete"
  | "close";

/**
 * Posts an event to the host Yelo app.
 *
 * The contract is `window.paymentHandler.postMessage(event)`, but how that
 * object reaches the page depends on the native WebView:
 *   - Android `addJavascriptInterface` / an injected shim → `window.paymentHandler`
 *   - iOS `WKScriptMessageHandler` named "paymentHandler" →
 *     `window.webkit.messageHandlers.paymentHandler`
 *   - react-native-webview → `window.ReactNativeWebView`
 * Each is tried in that order so the event is not silently dropped on a
 * platform that registered the handler its own native way.
 */
export function notifyApp(event: YeloAppBridgeEvent): boolean {
  const w = window as any;
  const targets = [
    w.paymentHandler,
    w.webkit?.messageHandlers?.paymentHandler,
    w.ReactNativeWebView,
  ];

  for (const target of targets) {
    if (typeof target?.postMessage === "function") {
      try {
        target.postMessage(event);
        return true;
      } catch {
        // try the next bridge
      }
    }
  }
  return false;
}
